<template>
  <div class="cylinder flexColumn title_text">
    <h1 class="cylinder-title padding page-title">
      Расчет трубки
    </h1>
    <div class="cylinder-inputs padding flexRow">
      <div class="cylinder-inputs-thickness">
        Толщина заготовки мм.
        <castom-input
            v-model="cylinderInput.thickness"
            class="inputMargin"
            :required="isRequired"
        />
      </div>
      <div class="cylinder-inputs-diameter">
        Требуевый диаметр мм.
        <castom-input
            v-model="cylinderInput.diameter"
            :required="isRequired"
            class="inputMargin"
        />
      </div>
    </div>
    <div class="cylinder-select padding flexRow">
<!--      <div>-->
        <img class="cylinder-select-svg" :src="img">
<!--      </div>-->
      <div class="cylinder-select-select">
        <castom-select
            :placeholder="'По внешнему диаметру'"
            :options="types.options"
            :required="isRequired"
            style="width: auto"
            @change="updateType"
        />
      </div>
    </div>
    <div class="padding"/>
    <div class="cylinder-results" v-if="result">
      <span v-if="result > 0">
        Ширина заготовки:
      </span>
       {{ result }}
      <span v-if="result > 0">
        мм.
      </span>
    </div>
  </div>
</template>

<script setup>

import {computed, reactive, ref} from "vue";
import CastomInput from "@/components/inputs/CastomInput";
import CastomSelect from '@/components/selects/CastomSelect'
import { useComputedCalculationTracking } from '@/helpers/calculationAnalytics'

const isRequired = ref(false)
const cylinderInput = reactive({
  name: '',
  diameter: '',
  thickness: '',
  type: 0
})

if (window.gtag) {
  window.gtag('event', 'cylinder_calculator', {})
}

const result = computed(() => {
  const thickness = parseFloat(cylinderInput.thickness);
  const diameter = parseFloat(cylinderInput.diameter);
  let blankWidth = 0
  if (!thickness || !diameter || thickness <= 0 || diameter <= 0) {
    return ''
  }
  switch (cylinderInput.type) {
    case 0:
      blankWidth = Math.PI * (diameter - thickness)
      break
    case 1:
      blankWidth = Math.PI * (diameter + thickness)
      break
    case 2:
      blankWidth = Math.PI * diameter
      break
  }
  if(blankWidth <= 0) return 'Проверьте корректность введенных данных'
  return blankWidth.toFixed(2);
});
useComputedCalculationTracking('cylinder', result)
const img = computed(()=> {
  return types.options[cylinderInput.type].src
})
const updateType = (selectedOption) => {
  if (selectedOption) {
    cylinderInput.type = selectedOption.type;
    cylinderInput.name = selectedOption.name;
  }
}
const types = reactive( {
  options: [
    {
      type: 0,
      name: 'По внешнему диаметру',
      src: require("../../../images/celinder/external.svg")
    },
    {
      type: 1,
      name: 'По внутреннему диаметру',
      src: require("../../../images/celinder/interior.svg")
    },
    {
      type: 2,
      name: 'По среднему диаметру',
      src: require("../../../images/celinder/central.svg")
    }
  ]
})
</script>

<style scoped lang="scss">
.cylinder {
  width: 100%;
  height: calc(100vh - 140px);;
  text-align: center;
  align-items: center;
  &-inputs {
    font-size: 14px;
    text-align: center;
    justify-content: space-between;
    &-diameter {
      width: 40%;
    }
    &-thickness {
      width: 40%;
    }
  }
  &-select {
    justify-content: space-between;
    &-select {
      width: 60%;
      align-items: center;
      display: flex;
      justify-content: center;
    }
    &-svg {
      height: 125px;
    }
  }
  &-results {
    margin-bottom: 20px;
    border-radius: 25px;
    border: 2px solid #fff;
    height: auto;
    padding: 10px;
    box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.25);
    background: linear-gradient(180deg, rgba(181, 162, 189, 0.33) 0%, rgba(26, 21, 28, 0.33) 100%);
    gap: 7px;
  }
}
.title_text {
  color: white;
}
.padding {
  width: 100%;
  border: 2px solid white;
  border-left: none;
  border-right: none;
  border-bottom: none;
  padding: 10px 0;
}
.flexColumn {
  display: flex;
  flex-direction: column;
}
.flexRow {
  display: flex;
  flex-direction: row;
}
.inputMargin {
  margin-top: 10px;
}
</style>
